import { render } from "./MatrixText.vue?vue&type=template&id=1927f046"
import script from "./MatrixText.vue?vue&type=script&lang=js"
export * from "./MatrixText.vue?vue&type=script&lang=js"

import "./MatrixText.vue?vue&type=style&index=0&id=1927f046&lang=css"

import exportComponent from "/home/angelkiro/Dev/SVPhysio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__